import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-transaction",
  "use": "icon-transaction-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-transaction\"><path d=\"M853.4016 170.7008H170.752c-47.36 0-84.9408 37.9904-84.9408 85.3504l-0.4096 512a84.992 84.992 0 0 0 85.3504 85.2992h682.6496a84.992 84.992 0 0 0 85.3504-85.2992V256a84.992 84.992 0 0 0-85.3504-85.3504z m0 597.3504H170.752v-256h682.6496v256z m0-426.7008H170.752V256.0512h682.6496v85.2992z\" p-id=\"2012\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol